<template>
  <div>
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="12" md="5" lg="4" class="align-self-center">
          <h2>Reset user password</h2>
          <form>
            <div class="form-group">
              <label for="form_email">User E-Mail</label>
              <input v-model="email" type="text" class="form-control" id="form_email" placeholder="User E-Mail" />
            </div>
            <div class="form-group">
              <label for="form_pw">New Password</label>
              <input v-model="newPassword" type="text" class="form-control" id="form_pw" placeholder="New Password" />
            </div>
          </form>
        </b-col>
        <p>
          Please give the new password to the user by yourself (best over the phone for security reasons), as it will
          NOT be sent to them automatically!
        </p>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="8" class="text-center">
          <hr />
          <div class="btn btn-lg btn-success" @click="handleResetPassword">
            Set new password
          </div>
          <hr />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import apiAuth from 'src/clients/apiAuth';

import constants from 'src/constants/constants';

export default {
  data: () => {
    return {
      email: '',
      newPassword: '',
    };
  },
  methods: {
    handleResetPassword() {
      let options = {
        method: 'post',
        baseURL: constants.url.userService.baseUrl,
        url: constants.url.userService.api.resetPassword,
        data: {
          email: this.email,
          password: this.newPassword,
        },
      };
      apiAuth(options)
        .then(() => {
          alert('Successfully changed the password for:\n' + this.email);

          this.email = '';
          this.newPassword = '';
        })
        .catch((error) => {
          let errorMsg = `Errorcode ${error.response.status} - ${error.response.statusText} \n
There was an error, while trying to reset the password. Server responds: \n
${error.response.data}`;

          alert(errorMsg);
        });
    },
  },
};
</script>

<style scoped></style>
